/* Utils */
import {turkishCharacterConverter} from '../../../common/string/stringUtils';
import {generateAppliedFacetsStringForWebtrekk} from '../../filter/filterUtils';

/* Constants */
import {DAVINCI_PAGE_TYPES} from '../davinci/davinciConstants';
import {FACET_QUERY_PARAM_NAMES} from '../../../views/filter/facet/facetConstants';
import {
  WEBTREKK_CONSTANTS,
  WEBTREKK_BRAND_PAGE_CONSTANTS,
  WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS,
  WEBTREKK_CATEGORY_PAGE_CONSTANTS,
  WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS,
  WEBTREKK_SEARCH_PAGE_CONSTANTS,
  WEBTREKK_TAG_PAGE_CONSTANTS,
  WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS,
} from './webtrekkConstants';
import {LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE} from '../../../common/pagination/paginationConstants';

function generateCategoryPageWebtrekkInitialData(contentId = null) {
  return {
    contentId: contentId || WEBTREKK_CATEGORY_PAGE_CONSTANTS.CONTENT_ID,
    contentGroup: {
      [WEBTREKK_CATEGORY_PAGE_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: WEBTREKK_CATEGORY_PAGE_CONSTANTS.SITE,
    },
    customSessionParameter: {
      [WEBTREKK_CATEGORY_PAGE_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
    customParameter: {
      [WEBTREKK_CATEGORY_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY]: '',
      [WEBTREKK_CATEGORY_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_STATUS_KEY]: '',
    },
    customEcommerceParameter: {},
  };
}

function generateTagPageWebtrekkInitialData(contentId = null) {
  const utagPageValue = window.utagData ? window.utagData.page_value : '';
  return {
    contentId: contentId || WEBTREKK_TAG_PAGE_CONSTANTS.CONTENT_ID,
    contentGroup: {
      [WEBTREKK_TAG_PAGE_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: WEBTREKK_TAG_PAGE_CONSTANTS.SITE,
      [WEBTREKK_TAG_PAGE_CONSTANTS.CONTENT_GROUP_TAG_NAME_KEY]: utagPageValue,
    },
    customSessionParameter: {
      [WEBTREKK_TAG_PAGE_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
    customParameter: {
      [WEBTREKK_TAG_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY]: '',
      [WEBTREKK_TAG_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_STATUS_KEY]: '',
    },
    customEcommerceParameter: {},
  };
}

function generateSearchPageWebtrekkInitialData(contentId = null) {
  const utagPageValue = window.utagData ? window.utagData.page_value : '';
  return {
    contentId: contentId || WEBTREKK_SEARCH_PAGE_CONSTANTS.CONTENT_ID,
    contentGroup: {
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: WEBTREKK_SEARCH_PAGE_CONSTANTS.SITE,
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CONTENT_GROUP_SEARCH_NAME_KEY]: utagPageValue,
    },
    customSessionParameter: {
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
    customParameter: {
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY]: '',
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_STATUS_KEY]: '',
    },
    customEcommerceParameter: {},
  };
}

function generateSearchPageWebtrekkData(queryParams, appliedFacetArray, totalSearchPageProductCount, platform) {
  return {
    contentId: `${platform || WEBTREKK_SEARCH_PAGE_CONSTANTS.SITE}-${WEBTREKK_SEARCH_PAGE_CONSTANTS.SEARCH}`,
    contentGroup: {
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: platform || WEBTREKK_SEARCH_PAGE_CONSTANTS.SITE,
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CONTENT_GROUP_SEARCH_PAGE_TYPE]: WEBTREKK_SEARCH_PAGE_CONSTANTS.SEARCH,
    },
    customSessionParameter: {
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
    internalSearch: queryParams[FACET_QUERY_PARAM_NAMES.QUERY],
    customParameter: {
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CUSTOM_PARAM_TOTAL_SEARCH_COUNT]: `${totalSearchPageProductCount}`,
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CUSTOM_PARAM_TOTAL_SEARCH_PAGE_COUNT]: totalSearchPageProductCount < LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE ? `${totalSearchPageProductCount}` : LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE.toString(),
      [WEBTREKK_SEARCH_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY]: appliedFacetArray ? generateAppliedFacetsStringForWebtrekk(appliedFacetArray) : '',
    },
    customEcommerceParameter: {},
  };
}

function generateTagPageWebtrekkData(queryParams, appliedFacetArray, totalTagProductCount, totalTagPageProductCount, utagPageValue) {
  return {
    contentId: `${WEBTREKK_TAG_PAGE_CONSTANTS.SITE}-${utagPageValue}-${WEBTREKK_TAG_PAGE_CONSTANTS.TAG_PAGE}`,
    contentGroup: {
      [WEBTREKK_TAG_PAGE_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: WEBTREKK_TAG_PAGE_CONSTANTS.SITE,
      [WEBTREKK_TAG_PAGE_CONSTANTS.CONTENT_GROUP_TAG_PAGE_TYPE]: WEBTREKK_TAG_PAGE_CONSTANTS.TAG_PAGE,
      [WEBTREKK_TAG_PAGE_CONSTANTS.CONTENT_GROUP_TAG_NAME_KEY]: utagPageValue,
    },
    customSessionParameter: {
      [WEBTREKK_TAG_PAGE_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
    internalSearch: queryParams[FACET_QUERY_PARAM_NAMES.QUERY],
    customParameter: {
      [WEBTREKK_TAG_PAGE_CONSTANTS.CUSTOM_PARAM_TOTAL_SEARCH_COUNT]: `${totalTagPageProductCount}`,
      [WEBTREKK_TAG_PAGE_CONSTANTS.CUSTOM_PARAM_TOTAL_SEARCH_PAGE_COUNT]: totalTagPageProductCount < LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE ? `${totalTagPageProductCount}` : LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE.toString(),
      [WEBTREKK_TAG_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY]: appliedFacetArray ? generateAppliedFacetsStringForWebtrekk(appliedFacetArray) : '',
    },
    customEcommerceParameter: {},
  };
}

function generateTagPageDesktopWebtrekkData(appliedFacetArray, totalProductCount, tagId) {
  return {
    contentId: `${WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.SITE}-${tagId}-${WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.TAG_PAGE}`,
    contentGroup: {
      [WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.SITE,
      [WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.CONTENT_GROUP_TAG_PAGE_TYPE]: WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.TAG_PAGE,
      [WEBTREKK_TAG_PAGE_CONSTANTS.CONTENT_GROUP_TAG_NAME_KEY]: tagId,
    },
    customSessionParameter: {
      [WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
    customParameter: {
      [WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.CUSTOM_PARAM_TOTAL_SEARCH_COUNT]: `${totalProductCount}`,
      [WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.CUSTOM_PARAM_TOTAL_SEARCH_PAGE_COUNT]: totalProductCount < LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE ? `${totalProductCount}` : LISTING_PRODUCTS_COUNT_FOR_ONE_PAGE.toString(),
      [WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY]: appliedFacetArray ? generateAppliedFacetsStringForWebtrekk(appliedFacetArray) : '',
    },
    customEcommerceParameter: {},
  };
}

function generateBrandPageWebtrekkData(queryParams, appliedFacetArray, totalBrandProductCount, totalBrandPageProductCount, utagPageValue, brandId) {
  return {
    contentId: `${WEBTREKK_BRAND_PAGE_CONSTANTS.SITE}-${utagPageValue}-${brandId}`,
    contentGroup: {
      [WEBTREKK_BRAND_PAGE_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: WEBTREKK_BRAND_PAGE_CONSTANTS.SITE,
      [WEBTREKK_BRAND_PAGE_CONSTANTS.CONTENT_GROUP_BRAND_PAGE_TYPE]: WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS.BRAND_PAGE,
      [WEBTREKK_BRAND_PAGE_CONSTANTS.CONTENT_GROUP_BRAND_KEY]: brandId,
    },
    customSessionParameter: {
      [WEBTREKK_BRAND_PAGE_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
  };
}

function generateBrandPageDesktopWebtrekkData(queryParams, appliedFacetArray, totalBrandProductCount, totalBrandPageProductCount, utagPageValue, brandId) {
  return {
    contentId: `${WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS.SITE}-${utagPageValue}-${brandId}`,
    contentGroup: {
      [WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS.SITE,
      [WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS.CONTENT_GROUP_BRAND_PAGE_TYPE]: WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS.BRAND_PAGE,
      [WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS.CONTENT_GROUP_BRAND_KEY]: brandId,
    },
    customSessionParameter: {
      [WEBTREKK_BRAND_PAGE_DESKTOP_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
  };
}

function generateMerchantPageWebtrekkData(queryParams, appliedFacetArray, totalMerchantProductCount, totalMerchantPageProductCount, utagPageValue, merchantId) {
  return {
    contentId: `${WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS.SITE}-${utagPageValue.join('-')}-MerchantName:${merchantId}`,
    contentGroup: {
      [WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS.SITE,
      [WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS.CONTENT_GROUP_MERCHANT_PAGE_TYPE]: WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS.MERCHANT_PAGE,
      [WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS.CONTENT_GROUP_MERCHANT_KEY]: utagPageValue.toString(),
    },
    customSessionParameter: {
      [WEBTREKK_MERCHANT_DESKTOP_PAGE_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
  };
}


function generateCategoryHierarchyForWebtrekk(category, webtrekkData, tagId) {
  let index = 2;

  if (category?.breadcrumbArray) {
    category?.breadcrumbArray?.forEach((breadcrumb) => {
      if (webtrekkData.contentGroup) {
        webtrekkData.contentGroup[index] = breadcrumb?.name
      }
      index += 1;
    })
  }

  if (category && category.parents) {
    category.parents.forEach(parentCategory => {
      webtrekkData.contentGroup[index] = turkishCharacterConverter(parentCategory.categoryName);
      index += 1;
    })
  }

  if (category && category.categoryName) {
    webtrekkData.contentGroup[index] = turkishCharacterConverter(category.categoryName);
  }

  if (tagId) {
    WEBTREKK_TAG_PAGE_DESKTOP_CONSTANTS.CONTENT_GROUP_TAG_KEY = tagId;
  } else {
    webtrekkData.contentGroup[index + 1] = WEBTREKK_CATEGORY_PAGE_CONSTANTS.CATEGORY_PAGE;
  }
}

function generateHierarchyFromAppliedFilters(appliedFilters) {
  return appliedFilters
    ?.filter((filter) => filter?.name === 'Kategori')
    ?.map((filter) => {
      return {name: filter?.selectedValues?.[0]?.displayName}
    })
}

function generateUserInfoForWebtrekk(webtrekkData, isAuthenticated) {
  webtrekkData.customSessionParameter[WEBTREKK_CATEGORY_PAGE_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY] = isAuthenticated
    ? WEBTREKK_CATEGORY_PAGE_CONSTANTS.LOGIN
    : WEBTREKK_CATEGORY_PAGE_CONSTANTS.NOT_LOGIN;
}

function generateFiltersForWebtrekk(appliedFacetArray, webtrekkData, isClosedCategory) {
  webtrekkData.customParameter = webtrekkData.customParameter || {};
  webtrekkData.customParameter[WEBTREKK_CATEGORY_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY] = generateAppliedFacetsStringForWebtrekk(appliedFacetArray);
  webtrekkData.customParameter[WEBTREKK_CATEGORY_PAGE_CONSTANTS.CUSTOM_PARAM_CATEGORY_STATUS_KEY] = isClosedCategory
    ? WEBTREKK_CATEGORY_PAGE_CONSTANTS.IN_ACTIVE
    : WEBTREKK_CATEGORY_PAGE_CONSTANTS.ACTIVE;
}

function generateOtherWebtrekkInfo(webtrekkData, product) {
  webtrekkData.product = product.sku;
  webtrekkData.productQuantity = WEBTREKK_CATEGORY_PAGE_CONSTANTS.PRODUCT_QUANTITY;
  webtrekkData.productStatus = WEBTREKK_CATEGORY_PAGE_CONSTANTS.PRODUCT_STATUS;
}

function generateAddToCartClickWebtrekkData(isUserAuthenticated, category, appliedFacetArray, isClosedCategory, product, pageTypeForDavinci) {
  let webtrekkData;
  if (pageTypeForDavinci === DAVINCI_PAGE_TYPES.CATEGORY) {
    webtrekkData = generateCategoryPageWebtrekkInitialData();
  } else if (pageTypeForDavinci === DAVINCI_PAGE_TYPES.SEARCH) {
    webtrekkData = generateSearchPageWebtrekkInitialData();
  } else if (pageTypeForDavinci === DAVINCI_PAGE_TYPES.TAG) {
    webtrekkData = generateTagPageWebtrekkInitialData();
  }
  if (webtrekkData) {
    generateUserInfoForWebtrekk(webtrekkData, isUserAuthenticated);
    generateWebtrekkAddToCartClick(category, product, webtrekkData, pageTypeForDavinci);
    generateFiltersForWebtrekk(appliedFacetArray, webtrekkData, isClosedCategory);
    generateOtherWebtrekkInfo(webtrekkData, product);
  }
  return webtrekkData;
}

function generateWebtrekkInitialData(contentId = null, platform) {
  return {
    contentId: contentId || WEBTREKK_CONSTANTS.CONTENT_ID,
    contentGroup: {
      [WEBTREKK_CONSTANTS.CONTENT_GROUP_SITE_TYPE_KEY]: platform || WEBTREKK_CONSTANTS.SITE,
    },
    customSessionParameter: {
      [WEBTREKK_CONSTANTS.CUSTOM_SESSION_AUTH_TYPE_KEY]: '',
    },
    customParameter: {
      [WEBTREKK_CONSTANTS.CUSTOM_PARAM_CATEGORY_HIERARCHY_KEY]: '',
      [WEBTREKK_CONSTANTS.CUSTOM_PARAM_CATEGORY_STATUS_KEY]: '',
    },
  };

}

function generateWebtrekkAddToCartClick(category, product, webtrekkData, pageTypeForDavinci) {
  let page,pageWithSuffix;
  if (pageTypeForDavinci === DAVINCI_PAGE_TYPES.CATEGORY) {
    page = WEBTREKK_CATEGORY_PAGE_CONSTANTS.CATEGORY;
    pageWithSuffix = WEBTREKK_CATEGORY_PAGE_CONSTANTS.CATEGORY_PAGE;
  } else if (pageTypeForDavinci === DAVINCI_PAGE_TYPES.SEARCH) {
    page = WEBTREKK_SEARCH_PAGE_CONSTANTS.SEARCH;
    pageWithSuffix = WEBTREKK_SEARCH_PAGE_CONSTANTS.SEARCH_PAGE;
  } else if (pageTypeForDavinci === DAVINCI_PAGE_TYPES.TAG) {
    page = WEBTREKK_TAG_PAGE_CONSTANTS.TAG;
    pageWithSuffix = WEBTREKK_TAG_PAGE_CONSTANTS.TAG_PAGE;
  }
  const categoryHierarchy = window?.utagData?.category_name_hierarchy;
  const categoryHierarchyWithPrefix = categoryHierarchy
    ? `${pageWithSuffix} > ${categoryHierarchy}`
    : pageWithSuffix;

  webtrekkData.contentGroup[WEBTREKK_CONSTANTS.CONTENT_GROUP_ADD_TO_CART_TYPE_KEY] = WEBTREKK_CONSTANTS.ADD_TO_CART_TYPE;
  webtrekkData.contentGroup[WEBTREKK_CONSTANTS.CONTENT_GROUP_PAGE_TYPE] = page;
  webtrekkData.contentGroup[WEBTREKK_CONSTANTS.CONTENT_GROUP_PAGE_URL] = window?.location?.href || '';

  webtrekkData.customEcommerceParameter[WEBTREKK_CONSTANTS.CUSTOM_PARAM_ADD_TO_CART_CATEGORY_HIERARCHY] = categoryHierarchyWithPrefix || '';
  webtrekkData.customEcommerceParameter[WEBTREKK_CONSTANTS.CUSTOM_PARAM_ADD_TO_CART_PLACEMENT] = 'Listing';
  webtrekkData.customEcommerceParameter[WEBTREKK_CONSTANTS.CUSTOM_PARAM_ADD_TO_CART_MERCHANT_NAME] = product.merchantName || '';
  webtrekkData.customEcommerceParameter[WEBTREKK_CONSTANTS.CUSTOM_PARAM_ADD_TO_CART_MERCHANT_ID] = product.merchantId || '';
}


function generateContentIdArrayForWebtrekk(category, platform) {
  let categoryHierarchyArray;

  if (platform) {
    categoryHierarchyArray = [platform]
  } else {
    categoryHierarchyArray = ['Mobile']
  }

  if (category?.breadcrumbArray) {
    category?.breadcrumbArray?.forEach((breadcrumb) => {
      categoryHierarchyArray.push(turkishCharacterConverter(breadcrumb?.name))
    })
  }

  if (category && category.parents) {
    category.parents.forEach((parentCategory, categoryIndex) => {
      if (parentCategory && parentCategory.categoryName) {
        categoryHierarchyArray.push(turkishCharacterConverter(parentCategory.categoryName));
      }
    })
  }

  if (category && category.categoryName) {
    categoryHierarchyArray.push(turkishCharacterConverter(category.categoryName));
  }

  categoryHierarchyArray.push(WEBTREKK_CATEGORY_PAGE_CONSTANTS.CATEGORY_PAGE);

  return categoryHierarchyArray;
}


function getCategoryNameHierarchy(predicate, category, selectedCategoryDto) {
  let nameHierarchy = [];
  if (category.children != null && category.children.length > 0) {
    if (category.children.length > 1 && selectedCategoryDto == null) {
      nameHierarchy.push(category.children.sort((a, b) => b.itemsCount - a.itemsCount)[0].categoryName);
    } else {
      let result = category.children.find(predicate);
      if (result != null) {
        nameHierarchy.push(result.categoryName);
        return nameHierarchy;
      }
      for (let i = 0; i < category.children.length; i++) {
        let childCategory = category.children[i];
        nameHierarchy.push(childCategory.categoryName);
        nameHierarchy = nameHierarchy.concat(getCategoryNameHierarchy(predicate, childCategory, selectedCategoryDto));
      }
    }
  }
  return nameHierarchy;
}


export {
  generateCategoryHierarchyForWebtrekk,
  generateContentIdArrayForWebtrekk,
  generateFiltersForWebtrekk,
  generateUserInfoForWebtrekk,
  generateWebtrekkInitialData,
  generateCategoryPageWebtrekkInitialData,
  generateTagPageWebtrekkInitialData,
  generateAddToCartClickWebtrekkData,
  generateSearchPageWebtrekkData,
  generateTagPageWebtrekkData,
  generateTagPageDesktopWebtrekkData,
  generateBrandPageWebtrekkData,
  generateBrandPageDesktopWebtrekkData,
  generateMerchantPageWebtrekkData,
  getCategoryNameHierarchy,
  generateHierarchyFromAppliedFilters
};
